import { baseApi } from '@Services/api';
import { RequestTypes } from '@Constants/api';

const loginApis = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    resetPasswordLink: builder.mutation({
      query: (payload) => ({
        url: '/v0/user/password/resetLink',
        method: RequestTypes.POST,
        body: payload
      })
    }),
    updateNewPassword: builder.mutation({
      query: (payload) => ({
        url: '/v0/user/password/reset',
        method: RequestTypes.POST,
        body: payload
      })
    })
  })
});

export const { useResetPasswordLinkMutation, useUpdateNewPasswordMutation } = loginApis;
